import React, {useEffect, useState} from 'react';
import "./onboard-checkbox-agreement-style.scss";
import UsageAgreementComponent from "../usage-agreement-component/UsageAgreementComponent";
import {ReactComponent as CheckboxIcon} from './images/checkbox.svg';
import {ReactComponent as CheckboxErrorIcon} from './images/checkbox-error.svg';
import {ReactComponent as CheckboxSelectIcon} from './images/checkbox-select.svg';
import {errorRandomReplace} from "../../../util/Validation";

const OnboardCheckboxAgreement = (props) => {
    const {value, error, onChange, label, description} = props;

    const [mValue, setMValue] = useState(value != null ? value : false);
    const [mError, setMError] = useState(error);

    const [agreementVisible, setAgreementVisible] = useState(false);
    const [agreementTitle, setAgreementTitle] = useState(null);
    const [agreementDescription, setAgreementDescription] = useState(null);
    const [agreementConfirm, setAgreementConfirm] = useState(false);

    useEffect(() => {
        let e = errorRandomReplace(error);
        setMError(e);
    }, [error]);

    useEffect(() => {
        if (value !== undefined && value !== null)
            setMValue(value);
    }, [value])

    const handleChange = (val) => {
        if (error !== undefined) {
            setMError(null);
        }
        setMValue(val.target.checked);
        if (onChange !== undefined)
            onChange(val.target.checked);
    }

    const handleConfirm = () => {
        handleChange({target: {checked: true}});
        setAgreementVisible(false);
    }

    const controlAgreement = (agreement) => {
        setAgreementVisible(true);
        setAgreementTitle(agreement.title);
        setAgreementConfirm(agreement.confirm);
        setAgreementDescription(agreement.description);
    }

    const controlLink = (link) => {
        window.open(link, '_blank', 'noopener, noreferrer');
    }

    const handleElementClick = (val) => {
        if (val.link === undefined)
            controlAgreement(val.agreement)
        else
            controlLink(val.link);
    }

    const setElement = (val) => {
        return <span className="onboard-checkbox-sub-t-a" onClick={() => handleElementClick(val)}>{val.text}</span>;
    }

    const clickElement = (val) => {
        return <span onClick={() => handleChange({target: {checked: !mValue}})}>
            {val}
        </span>;
    }

    const createLabel = () => {
        let value = label;
        if (value !== undefined && value !== null) {
            let a = value.label;
            let arr = [];
            if (value.link !== undefined)
                for (let i2 = 0; i2 < value.link.length; i2++) {
                    let splits = a.split(value.link[i2].text);
                    if (splits.length > 1) {
                        arr.push(clickElement(splits[0]));
                        if (value.link[i2].agreement !== undefined)
                            arr.push(setElement(value.link[i2]));
                        else
                            arr.push(setElement(value.link[i2]));
                        a = splits[1];
                        if (i2 === value.link.length - 1)
                            arr.push(clickElement(splits[1]));
                    }
                }
            else {
                return clickElement(a);
            }
            return arr.map((val, index) => {
                return <span key={index}>{val}</span>;
            });
        } else return <></>;
    }

    const createDescription = () => {
        let value = description;
        if (value !== undefined && value !== null) {
            let a = value.label;
            let arr = [];
            if (value.link !== undefined)
                for (let i2 = 0; i2 < value.link.length; i2++) {
                    let splits = a.split(value.link[i2].text);
                    if (splits.length > 1) {
                        arr.push(splits[0]);
                        if (value.link[i2].agreement !== undefined)
                            arr.push(setElement(value.link[i2]));
                        else
                            arr.push(setElement(value.link[i2]));
                        a = splits[1];
                        if (i2 === value.link.length - 1)
                            arr.push(splits[1]);
                    }
                }
            else return a;
            return arr.map((val, index) => {
                return <span key={index}>{val}</span>;
            });
        } else return <></>;
    }

    return (
        <div>
            <div>
                <div className="onboard-checkbox-root">
                    <div onClick={() => handleChange({target: {checked: !mValue}})}>
                        {!mValue ? (mError ? <CheckboxErrorIcon/> : <CheckboxIcon/>) : <CheckboxSelectIcon/>}
                    </div>
                    <input className="onboard-checkbox-checkmark-input" type="checkbox"
                           onChange={(e) => handleChange(e)}
                           checked={mValue}/>
                    <div
                        className={"onboard-checkbox-ff " + (mError ? 'onboard-checkbox-label-error' : '')}>{createLabel()}</div>
                </div>
                <p className="onboard-checkbox-sub">
                    {createDescription()}
                </p>
                {mError && (<div className="onboard-checkbox-error-hint">{mError}</div>)}
            </div>

            <UsageAgreementComponent visible={agreementVisible} showCancel
                                     showConfirm={agreementConfirm}
                                     cancel={() => setAgreementVisible(false)}
                                     confirm={() => handleConfirm()}
                                     title={agreementTitle}
                                     description={agreementDescription}
            />
        </div>
    )
};

export default OnboardCheckboxAgreement;
